import moment from 'moment-timezone';

export const QATAR_TIMEZONE = 'Asia/Qatar';

/** Minimum value for datetime-local inputs that represent Qatar time. */
export function getQatarDatetimeLocalMin(): string {
  return moment.tz(QATAR_TIMEZONE).format('YYYY-MM-DDTHH:mm');
}

/** Convert a datetime-local value (Qatar wall time) to a UTC ISO string. */
export function qatarDatetimeLocalToUtcIso(localValue: string): string {
  return moment.tz(localValue, QATAR_TIMEZONE).utc().toISOString();
}

/** Format a stored UTC date for display in Qatar time. */
export function formatQatarDateTime(date: string | Date): string {
  return moment(date).tz(QATAR_TIMEZONE).format('lll');
}
